import type {
  DeviceAssociationGetAllResponse,
  DeviceAssociationSearchParams,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class DeviceUseStatementApi {
  getDeviceUseStatements = async (
    params: DeviceAssociationSearchParams,
  ): Promise<DeviceAssociationGetAllResponse> =>
    await trpcClient.device.usage.getAll.query({ count: 20, ...params });
}
